import { render, staticRenderFns } from "./Assistant.vue?vue&type=template&id=25c1f99f&scoped=true&"
import script from "./Assistant.vue?vue&type=script&lang=js&"
export * from "./Assistant.vue?vue&type=script&lang=js&"
import style0 from "./Assistant.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Assistant.vue?vue&type=style&index=1&id=25c1f99f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1f99f",
  null
  
)

export default component.exports